import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, IconButton, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ChatLinkTarget } from '../../utils/chatLinkCorpus';
import ChatLinkTargetPreviewCard from './ChatLinkTargetPreviewCard';

interface ChatLinkTargetPreviewCarouselProps {
  targets: ChatLinkTarget[];
  onPreviewNavigate?: () => void;
}

const ChatLinkTargetPreviewCarousel: React.FC<ChatLinkTargetPreviewCarouselProps> = ({
  targets,
  onPreviewNavigate,
}) => {
  const [index, setIndex] = useState(0);
  const activeTarget = targets[index] ?? targets[0];
  const multiple = targets.length > 1;

  useEffect(() => {
    setIndex(0);
  }, [targets]);

  if (!activeTarget) {
    return null;
  }

  const showPrevious = () => {
    setIndex((current) => (current - 1 + targets.length) % targets.length);
  };

  const showNext = () => {
    setIndex((current) => (current + 1) % targets.length);
  };

  return (
    <Box>
      {multiple && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
            px: 1,
            pb: 0.5,
          }}
        >
          <IconButton size="small" aria-label="Previous match" onClick={showPrevious}>
            <ChevronLeftIcon fontSize="small" />
          </IconButton>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ minWidth: 72, textAlign: 'center' }}
          >
            {index + 1} of {targets.length}
          </Typography>
          <IconButton size="small" aria-label="Next match" onClick={showNext}>
            <ChevronRightIcon fontSize="small" />
          </IconButton>
        </Box>
      )}
      <ChatLinkTargetPreviewCard
        key={activeTarget.id}
        target={activeTarget}
        onPreviewNavigate={onPreviewNavigate}
      />
    </Box>
  );
};

export default ChatLinkTargetPreviewCarousel;
